import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { environmentVariables } from "../accounts/environmentVariables";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey:
            environmentVariables.APP_INSIGHTS_INSTRUMENTATION_KEY,
    },
});
appInsights.loadAppInsights();
appInsights.trackPageView();

store.$router = router;

createApp(App).use(router).use(store).mount("#mascom-devices");
